import {RadioGroupProps} from '@gravity-ui/uikit';
import {QuestionImage, QuestionItem} from 'common/models/survey';

export enum RadioQuestionView {
    Default = 'default',
    OneRow = 'onerow',
    Stars = 'stars',
}

export type RadioQuestionCardSize = 's' | 'm' | 'l' | 'xl';

export interface RadioQuestionProps extends RadioGroupProps {
    label: string;
    comment?: string;
    image?: QuestionImage;
    required: boolean;
    error?: string;
    items: QuestionItem[];
    id?: string;
    view?: RadioQuestionView;
    cardSize?: RadioQuestionCardSize;
}
